import styled from "styled-components";
import { ContentContainer } from "components/ui/display/ContentContainer";

import { NotesGridCard } from "./NotesGridCard";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const NotesGrid = ({notes, createNote, editNote, archiveNote}) => {
    return (
        <StyledNotesGrid>
            <StyledNotesGridNewNote padding="md" dropShadow='sm' onClick={createNote}>
                <div className="newNoteCardHeader">
                    <div className="iconContainer">
                        <MaterialIcon
                            name='add'
                            weight={300}
                            size="lg"
                        />
                    </div>
                </div>
                <div className="newNoteCardContent">
                    Ny notat
                </div>
                <div className="newNoteCardFooter">
                    <MaterialIcon
                        name='arrow_forward'
                        weight={300}
                        size="sm"
                        color={({theme}) => theme.colors.mutedForeground}
                    />
                </div>
            </StyledNotesGridNewNote>

            {
                notes.map(note => note ? <NotesGridCard
                                            key={note.noteUuid}
                                            note={note}
                                            onEdit={() => {editNote(note.noteUuid, note.noteTitle)}}
                                            onArchive={() => archiveNote(note.noteUuid)}
                                        /> : null) 
            }
        </StyledNotesGrid>
    )
}

const StyledNotesGrid = styled.div`
    display: flex;
    gap: ${({theme}) => theme.spacing.lg};
    flex-wrap: wrap;

    > div, > a
    {
        @media (min-width: ${({theme}) => theme.breakPoints.xxl})
        {
            width: calc((100% - 3 * ${({theme}) => theme.spacing.lg}) / 4);
        }

        @media (max-width: ${({theme}) => theme.breakPoints.xxl})
        {
            width: calc((100% - 2 * ${({theme}) => theme.spacing.lg}) / 3);
        }

        @media (max-width: ${({theme}) => theme.breakPoints.xl})
        {
            width: calc((100% - 1 * ${({theme}) => theme.spacing.lg}) / 2);
        }

        @media (max-width: ${({theme}) => theme.breakPoints.lg})
        {
            min-width: 100%;
        }
    }
`

const StyledNotesGridNewNote = styled(ContentContainer)`

    cursor: pointer;
    height: 225px;
    
    div.newNoteCardHeader
    {
        padding: ${({theme}) => theme.spacing.md};

        div.iconContainer
        {
            width: 38px;
            height: 38px;
            background: ${({theme}) => theme.colors.neutralSecondaryForeground};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${({theme}) => theme.colors.neutralPrimaryBackground};
        }
    }

    div.newNoteCardContent
    {
        padding: 0 ${({theme}) => theme.spacing.md};
        margin-bottom: ${({theme}) => theme.spacing.md};
        font-weight: 600;
        flex: 1;
    }

    div.newNoteCardFooter
    {
        border-top: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.md};
        padding-bottom: 0;
        display: flex;
        justify-content: flex-end;
    }

`

